/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IDobbiesVendorOnBoardViewProps } from './dobbies-vendor-on-board';

export default (props: IDobbiesVendorOnBoardViewProps) => {
    const {
        resources: { companyHeading, contactHeading },
        heading,
        description,
        companyInfoForm,
        contactInfoForm,
        recaptcha,
        formButton,
        formFunction
    } = props;
    return (
        <div className='ms-vendor-on-board col-lg-7 m-auto'>
            <div className='row'>
                <div className='col-12 text-center'>
                    <Node className='ms-vendor-on-board__header'>
                        {heading}
                        {description}
                    </Node>
                </div>
                <div className='col-12'>
                    <form onSubmit={formFunction}>
                        <h2>{companyHeading}</h2>
                        <div className='row'>{companyInfoForm}</div>
                        <h2>{contactHeading}</h2>
                        <div className='row'>{contactInfoForm}</div>
                        {formButton}
                        {recaptcha}
                    </form>
                </div>
            </div>
        </div>
    );
};
